import { createSelector } from "@reduxjs/toolkit";
import { type RootState } from "../store";
import { type SearchParamsI } from "../slices/inboxSlice";

export const selectMailsData = createSelector(
  (state: RootState) => state.inbox.mailsData,
  (mailsData) => mailsData
);

export const selectMailsQuantity = createSelector(
  (state: RootState) => state.inbox.mailsQuantity,
  (mailsQuantity) => mailsQuantity
);

export const selectIsFetching = createSelector(
  (state: RootState) => state.inbox.isFetching,
  (isFetching) => isFetching
);

export const selectSortBy = createSelector(
  (state: RootState) => state.inbox.searchParams.sortBy,
  (sortBy) => sortBy
);

export const selectIsSortAsc = createSelector(
  (state: RootState) => state.inbox.searchParams.isSortAsc,
  (sortAsc) => sortAsc
);

export const selectHoveredMail = createSelector(
  (state: RootState) =>
    state.inbox.mailsData?.[state.inbox.hoveredMailId || ""],
  (hoveredMail) => hoveredMail
);

export const selectHoveredMailId = createSelector(
  (state: RootState) => state.inbox.hoveredMailId,
  (hoveredMailId) => hoveredMailId
);

export const selectSelectedMail = createSelector(
  (state: RootState) =>
    state.inbox.mailsData?.[state.inbox.selectedMailId || ""],
  (selectedMail) => selectedMail
);

export const selectSelectedMailId = createSelector(
  (state: RootState) => state.inbox.selectedMailId,
  (selectedMailId) => selectedMailId
);

export const selectSearchParams = createSelector(
  (state: RootState): SearchParamsI => {
    const tParam = state.inbox.searchParams.t;

    return (state.inbox.searchParams as any)[tParam];
  },
  (searchParams) => ({
    ...searchParams,
    sm: searchParams?.sm?.length ? searchParams.sm.filter((sm) => !!sm) : [],
  })
);

export const selectAllSearchParams = createSelector(
  (state: RootState) => state.inbox.searchParams,
  (searchParams) => searchParams
);

export const selectPickerSearchParams = createSelector(
  (state: RootState) => state.inbox.searchParams.picker,
  (pickerSearchParams) => ({
    ...pickerSearchParams,
    ps: pickerSearchParams?.ps.length
      ? pickerSearchParams.ps.filter((p) => !!p)
      : [],
  })
);

export const selectTParam = createSelector(
  (state: RootState) => state.inbox.searchParams.t,
  (tParam) => tParam
);

export const selectFParam = createSelector(
  (state: RootState) => state.inbox.searchParams.f,
  (fParam) => fParam
);

export const selectCurrentPage = createSelector(
  (state: RootState) => +(state.inbox.searchParams.pn || 1),
  (currentPage) => currentPage
);

/**
 * @deprecated Use selectSelectedMailIds instead
 */
export const selectSelectedList = createSelector(
  (state: RootState) => state.inbox.selectedMailIds,
  (selectedList) => selectedList
);

export const selectSelectedMailIds = createSelector(
  (state: RootState) => state.inbox.selectedMailIds,
  (selectedMailIds) => selectedMailIds
);

export const selectCurrentSelectFilter = createSelector(
  (state: RootState) => state.inbox.currentSelectFilter,
  (currentSelectFilter) => currentSelectFilter
);

export const selectApiEnable = createSelector(
  (state: RootState) => state.inbox.apiEnable,
  (apiEnable) => apiEnable
);

export const selectFtpEnable = createSelector(
  (state: RootState) => state.inbox.ftpEnable,
  (ftpEnable) => ftpEnable
);

export const selectSplitView = createSelector(
  (state: RootState) => state.inbox.splitView,
  (splitView) => splitView
);

export const selectPreviewMail = createSelector(
  (state: RootState) => state.inbox.previewMail,
  (previewMail) => previewMail
);

export const selectIsFetchingSideInboxFiles = createSelector(
  (state: RootState) => state.inbox.isFetchingSideInboxFiles,
  (isFetchingSideInboxFiles) => isFetchingSideInboxFiles
);

export const selectSideInboxFiles = createSelector(
  (state: RootState) => state.inbox.sideInboxFiles,
  (sideInboxFiles) => sideInboxFiles
);

export const selectMailsCount = createSelector(
  (state: RootState) => state.inbox.mailsCount,
  (mailsCount) => mailsCount
);

export const selectFormList = createSelector(
  (state: RootState) => state.inbox.formList,
  (formList) => formList
);

export const selectLabels = createSelector(
  (state: RootState) => state.inbox.labels,
  (labels) => labels
);

export const selectSubUserList = createSelector(
  (state: RootState) => state.inbox.subUserList,
  (subUserList) => subUserList
);

export const selectItemsPerPage = createSelector(
  (state: RootState) => state.inbox.searchParams.itemsPerPage,
  (itemsPerPage) => itemsPerPage
);
